"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelList = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProductLabel = require("b2b-components/theme/components/ProductLabel");
var _classnames = _interopRequireDefault(require("classnames"));
require("./LabelList.scss");
var LabelList = function LabelList(_ref) {
  var size = _ref.size,
    className = _ref.className,
    isCoreAssortment = _ref.isCoreAssortment,
    isNew = _ref.isNew,
    isOccasion = _ref.isOccasion,
    isPromotion = _ref.isPromotion,
    isSellout = _ref.isSellout,
    isOwnAssortment = _ref.isOwnAssortment,
    text = _ref.text;
  if (!isOwnAssortment && !isCoreAssortment && !isNew && !isPromotion && !isOccasion && !isSellout) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-ProductBox-LabelList', className);
  var iconsSize = size || _ProductLabel.ProductLabel.config.size["default"];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, isOwnAssortment && /*#__PURE__*/_react["default"].createElement(_ProductLabel.ProductLabel, {
    className: "cds-ProductBox-Label",
    size: iconsSize,
    styleType: _ProductLabel.ProductLabel.config.styleType.ownAssortment,
    label: text.ownAssortment
  }), isCoreAssortment && /*#__PURE__*/_react["default"].createElement(_ProductLabel.ProductLabel, {
    className: "cds-ProductBox-Label",
    size: iconsSize,
    styleType: _ProductLabel.ProductLabel.config.styleType.coreAssortment,
    label: text.coreAssortment
  }), isNew && /*#__PURE__*/_react["default"].createElement(_ProductLabel.ProductLabel, {
    className: "cds-ProductBox-Label",
    size: _ProductLabel.ProductLabel.config.size.small,
    styleType: _ProductLabel.ProductLabel.config.styleType["new"],
    label: text["new"]
  }), isPromotion && /*#__PURE__*/_react["default"].createElement(_ProductLabel.ProductLabel, {
    className: "cds-ProductBox-Label",
    size: _ProductLabel.ProductLabel.config.size.small,
    styleType: _ProductLabel.ProductLabel.config.styleType.promotion,
    label: text.promotion
  }), isOccasion && /*#__PURE__*/_react["default"].createElement(_ProductLabel.ProductLabel, {
    className: "cds-ProductBox-Label",
    size: _ProductLabel.ProductLabel.config.size.small,
    styleType: _ProductLabel.ProductLabel.config.styleType.occasion,
    label: text.occasion
  }), isSellout && /*#__PURE__*/_react["default"].createElement(_ProductLabel.ProductLabel, {
    className: "cds-ProductBox-Label",
    size: _ProductLabel.ProductLabel.config.size.small,
    styleType: _ProductLabel.ProductLabel.config.styleType.sellout,
    label: text.sellout
  }));
};
exports.LabelList = LabelList;
LabelList.ProductLabel = _ProductLabel.ProductLabel;